import useCreateSize from 'modules/products/hooks/use-create-size';
import {SizeProps, translatedSizeProps} from 'modules/products/types';
import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateSize: React.FC = () => {
  const {id} = useParams();
  const {getInput, getPriceInput} = useFormInputs<SizeProps>();

  return (
    <Creation
      translationKey={translatedSizeProps}
      onSubmit={() => useCreateSize(id!)}
      inputs={[getInput({name: 'name'}), getPriceInput({name: 'price'})]}
      border
    />
  );
};

export default CreateSize;
